import { getToken } from './auth'
import { isObject, getAllUrlParamStr } from './utils'
import { httpUrl, authScope } from './constant'
import cache from './cached'

// 是否登录
export function checkLogined() {
  const token = getToken();
  return !!token;
}

// 是否绑定
export function checkBound() {
  return cache.getBindingState() || false;
}

// 跳转微信获取code
export function redirecToWx(appId) {
  // 微信跳转后的URL：
  // 获取code后，在获取code：https://tactivity.quanyou.com.cn/front/?code=xxxx1&state=#/login?code=xxx2&state=&activityId=503&guideId=2179&parentId=202&sign=3d54xxx&timestamp=160xx&redirect=%2Ftabbar01
  // 订阅消息后：http://activity.quanyou.com.cn/front/?openid=xxx&template_id=xxx&action=confirm&reserved=activityTest&scene=1&code=xxx&state=#/tabbar01'
  
  // 当前路由：#/abc?k=v, => abc?k=v
  const currentHash = location.hash.substring(2).split('?')[0];
  const queryParam = getAllUrlParamStr(location.href, ['code']);
  console.log('queryParam', queryParam);

  // 当前的URL，微信获取code后，会跳转回来
  let urlNow = encodeURIComponent(`${httpUrl}${currentHash}?${queryParam}`);
  console.log('urlNow:', urlNow);

  // snsapi_base: 静默授权，获取openId 
  // snsapi_userinfo：非静默，获取用户信息，用户授权
  const scope = authScope;
  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${urlNow}&response_type=code&scope=${scope}#wechat_redirect`;
  window.location.replace(authUrl);
}